/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 14/5/2021
 */
export const LocationTypeId = Object.freeze({
	ZOOM: "zoom",
	GOOGLE_MEET: "GOOGLE_MEET",
})
